import Button from '@raydiant/raydial/components/Button';
import Dialog, {
  DialogBody,
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import * as paths from '../../routes/paths';
import * as D from '../../clients/mira/types/Device';
import history from '../../history';
import TextField from '@raydiant/raydial/components/TextField';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as deviceActions from '../../actions/devices';

interface DeviceRenameProps {
  isOpen: boolean;
  device: D.Device;
}

const DeviceRename = ({ isOpen, device }: DeviceRenameProps) => {
  const [updatedName, setUpdatedName] = useState(device.name);
  const dispatch = useDispatch();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    updateName();
    e.preventDefault();
  };

  const handleCancel = () => {
    history.push(paths.screens.pattern);
  };

  const handleNameChange = (value: string) => {
    setUpdatedName(value);
  };

  const updateDevice = useCallback(
    (updatedDevice: Partial<D.Device>) => {
      if (!device) return;
      dispatch(
        deviceActions.updateDevice(
          {
            ...device,
            ...updatedDevice,
          },
          {},
        ),
      );
    },
    [dispatch, device],
  );

  const updateName = useCallback(() => {
    if (!device) return;
    if (updatedName === null) return;
    if (updatedName === device.name) return;
    updateDevice({ name: updatedName });
    history.push(paths.screens.pattern);
  }, [updateDevice, updatedName, device]);

  return (
    <Modal isOpen={isOpen}>
      <Dialog showCloseButton onClose={handleCancel}>
        <DialogHeader>
          <DialogHeading>Rename Device</DialogHeading>
        </DialogHeader>

        <DialogBody
          as="form"
          onSubmit={onSubmit}
          className="grid gap-4 mb-8"
          id="rename-device-form"
        >
          <div className="px-4">
            <TextField
              value={updatedName}
              onChange={handleNameChange}
              autoFocus
            />
          </div>
        </DialogBody>

        <footer className="flex flex-wrap gap-6 pb-4 px-4">
          <Button
            size="large"
            variant="secondary"
            className="grow"
            onPress={handleCancel}
          >
            Cancel
          </Button>
          <Button
            size="large"
            variant="primary"
            className="grow"
            type="submit"
            form="rename-device-form"
          >
            Done
          </Button>
        </footer>
      </Dialog>
    </Modal>
  );
};

export default DeviceRename;
